import { desktop } from "@/desktop/bridge";

/**
 * Notificação do sistema operacional (central de notificações do Windows, macOS, Linux). No app
 * desktop é a notificação nativa (com a foto de quem mandou); na web, a do navegador.
 */
const handlers = new Map<string, () => void>();
let listening = false;

export function osNotify(n: {
  id: string;
  title: string;
  body?: string;
  icon?: string | null;
  onClick?: () => void;
}) {
  if (desktop?.notify) {
    if (!listening && desktop.onNotificationClick) {
      listening = true;
      desktop.onNotificationClick((id) => {
        handlers.get(id)?.();
        handlers.delete(id);
      });
    }
    if (n.onClick) handlers.set(n.id, n.onClick);
    if (handlers.size > 200) handlers.delete(handlers.keys().next().value!);
    desktop.notify({ id: n.id, title: n.title, ...(n.body ? { body: n.body } : {}), icon: n.icon ?? null });
    return;
  }
  const System = globalThis.Notification;
  if (typeof System === "undefined" || System.permission !== "granted") return;
  try {
    const note = new System(n.title, {
      body: n.body,
      icon: n.icon ?? "/brand/icon-192.png",
      tag: n.id,
      silent: true,
    });
    note.onclick = () => {
      window.focus();
      n.onClick?.();
    };
  } catch {
    // navegador que só notifica por service worker
  }
}
